import { Device } from '../types';

/**
 * FS-890: the two device editors (the Device List Edit modal and the device
 * Settings tab) compare their draft with the record as it was loaded — or as
 * last saved — so Save is offered only for a real change, and the path goes
 * to PUT /devices/:id only when the operator changed it. An unrelated edit
 * then never revalidates a path the API would refuse today (a legacy value,
 * or one under an option since removed), and never puts back a path another
 * operator has changed since this one loaded the device.
 */

/** Does any field of the draft differ from the baseline? */
export function deviceDraftChanged(draft: Device, baseline: Device): boolean {
  const keys = new Set([...Object.keys(draft), ...Object.keys(baseline)]);
  for (const key of keys) {
    if ((draft as any)[key] !== (baseline as any)[key]) return true;
  }
  return false;
}

/** Has the operator changed the device's entity path? */
export function entityPathChanged(draft: Device, baseline: Device): boolean {
  return (draft.entity_path ?? null) !== (baseline.entity_path ?? null);
}

/** The PUT body: the draft, with entity_path only when it changed. */
export function deviceUpdateBody(draft: Device, baseline: Device): Partial<Device> {
  if (entityPathChanged(draft, baseline)) return draft;
  const { entity_path: _unchanged, ...rest } = draft;
  return rest;
}
